import React from 'react';
import i18next from 'i18next';

import {
  GOOGLE_MAPS_API_KEY,
  MAP_STYLE
} from '~screens/Dashboard/screens/ProjectsIIRSA/screens/ProjectDetail/components/Map/constants';

import { BASE_MAPS, BaseMap } from './baseMap';
import styles from './styles.module.scss';
import './i18n';

// South America at a glance, from the Static Maps API: each thumbnail previews its own layer.
const THUMBNAIL = `https://maps.googleapis.com/maps/api/staticmap?center=-22,-60&zoom=2&size=150x150&key=${GOOGLE_MAPS_API_KEY}`;
const THUMBNAILS: Record<BaseMap, string> = {
  terrain: `${THUMBNAIL}&maptype=terrain`,
  light: `${THUMBNAIL}&maptype=roadmap&${MAP_STYLE}`,
  satellite: `${THUMBNAIL}&maptype=satellite`
};

interface Props {
  value: BaseMap;
  onChange: (baseMap: BaseMap) => void;
  className?: string;
}

/** Round thumbnails over the map to switch its base layer. */
const BaseMapSelector = ({ value, onChange, className }: Props) => (
  <div className={`${styles.selector} ${className || ''}`} role="group" aria-label={i18next.t('baseMap:label') as string}>
    {BASE_MAPS.map(baseMap => (
      <button
        key={baseMap}
        type="button"
        className={`${styles.option} ${baseMap === value ? styles.selected : ''}`}
        aria-pressed={baseMap === value}
        title={i18next.t(`baseMap:${baseMap}`) as string}
        onClick={() => onChange(baseMap)}
      >
        <img src={THUMBNAILS[baseMap]} alt={i18next.t(`baseMap:${baseMap}`) as string} />
      </button>
    ))}
  </div>
);

export default BaseMapSelector;
